import React from 'react';

import { useTranslate } from '@src/core/hooks';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import {
  MobileSummaryRow,
  MobileSummaryRowLabel,
  MobileSummaryRowMutedValue,
  MobileSummaryRowValue,
  SummarySection,
  SummaryTotalLabel,
  SummaryTotalRow,
  SummaryTotalValue,
} from '@src/features/cart';

import type { UseSaleChangeSummaryResult } from '../hooks/useSaleChangeSummary';

type SaleChangeSummaryTotalProps = {
  summary: UseSaleChangeSummaryResult;
  showTotal?: boolean;
};

export const SaleChangeSummaryTotal = (props: SaleChangeSummaryTotalProps) => {
  const { summary, showTotal = true } = props;
  const { i18n } = useTranslate();
  const { formatCents } = useCurrencyFormat();

  return (
    <SummarySection data-testid='sale-change-summary-total'>
      {summary.hasComparison ? (
        <>
          <MobileSummaryRow>
            <MobileSummaryRowLabel>{i18n('checkout_sale_change_previous_reservation')}</MobileSummaryRowLabel>
            <MobileSummaryRowMutedValue>{formatCents(summary.downAmount ?? 0)}</MobileSummaryRowMutedValue>
          </MobileSummaryRow>

          <MobileSummaryRow>
            <MobileSummaryRowLabel>{i18n('checkout_sale_change_new_reservation')}</MobileSummaryRowLabel>
            <MobileSummaryRowValue>{formatCents(summary.upAmount ?? 0)}</MobileSummaryRowValue>
          </MobileSummaryRow>
        </>
      ) : null}

      {showTotal ? (
        <SummaryTotalRow>
          <SummaryTotalLabel>{i18n('base_value')}</SummaryTotalLabel>
          <SummaryTotalValue>{formatCents(summary.totalAmountCents)}</SummaryTotalValue>
        </SummaryTotalRow>
      ) : null}
    </SummarySection>
  );
};

export default SaleChangeSummaryTotal;
